import {
  customerEditCustomer,
  newAddressCustomerInfoIntialValue,
  registeredAddressIntialErrorState,
  registeredContactIntialErrorState,
} from "../CustomerFormInitialValues";
import {
  CustomerContact,
  RegisterAddress,
  ResponseAddress,
  ResponseCustomerEditAccount,
} from "../Customer.types";
import {
  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
  CITY_CHARACTER_LIMIT,
  COMPANY_NAME_CHARACTER_LIMIT,
  COMPANY_TAXID_CHARACTER_LIMIT,
  CONTACT_FIRSTNAME_CHARACTER_LIMIT,
  CONTACT_LASTNAME_CHARACTER_LIMIT,
  EMAIL_CHARACTER_LIMIT,
  INVALID_PHONENUMBER,
  POSTALCODE_CHARACTER_LIMIT,
  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
  allowCharactersAndSpecialSymbols,
  allowSpecialCharacterExcludingSome,
  cityCharacterLimit,
  companyNameCharacterLimit,
  companyTaxIdCharacterLimit,
  contactNameCharacterLimit,
  emailCharacterLimit,
  numbersOnly,
  phoneNumberRegex,
  postalCodeCharacterLimit,
  taxIdPattern,
} from "../AddNewCustomerAccount/AddCustomerValidation";

export const CUSTOMER_NAME_REQUIRED = "Customer Name is Required Field";
//export const TAX_ID_REQUIRED = "Tax ID is Required Field";
export const LEADACCOUNT_ID_REQUIRED = "Msx Account ID is Required Field";
export const AUTHORIZED_BUYER_FIRSTNAME_REQUIRED =
  "First Name is Required Field";
export const AUTHORIZED_BUYER_LASTNAME_REQUIRED = "Last Name is Required Field";
export const AUTHORIZED_BUYER_PHONE_REQUIRED = "Phone is Required Field";
export const AUTHORIZED_BUYER_EMAIL_REQUIRED = "Email is Required Field";
export const STREET_REQUIRED = "Street is Required Field";
export const POSTALCODE_REQUIRED = "Zip/Postal code is Required Field";
export const CITY_REQUIRED = "City is Required Field";
export const PROVINCE_REQUIRED = "State/Province is Required Field";
export const COUNTRY_REQUIRED = "Country is Required Field";
export const BILLINGNAME_REQUIRED = "Billing Name is Required Field";
export const SHIPPINGNAME_REQUIRED = "Shipping Name is Required Field";
export const AFFILATION_REQUIRED = "Affilation is Required Field";
export const PAYMENT_TERMS_REQUIRED = "Payment Terms is Required Field";
export const TYPE_REQUIRED = "Type is Required Field";
export const SPECIAL_CHARACTERS_NOT_ALLOWED =
  "Special Characters are not allowed";
export const CHARACTERS_ALLOWED = "Only Characters are allowed";
export const NUMBERS_ALLOWED = "Only Numbers are allowed";
export const LENGTHS_ALLOWED = "Phone Number should contain 10 digits";
export const EMAIL_VALIDATION = "Email should be in correct format";
export const CUSTOMER_CERTIFIED_EMAIL_REQUIRED = "Customer Certified Email is required for Italy";
export const CUSTOMER_CONSIGNEE_CODE_REQUIRED = "Customer Consignee Code is required for Italy";
export const Street_PO_BOX_VALIDATION =
  "Street must not be a P.O Box Or invalid characters";
export const CONTACTS_REQUIRED = "Contacts is Required Field";

export const pattern = /^[a-zA-Z0-9 ]+$/;
export const letters = /^[A-Za-z ]+$/;
// export const numbers = /^\d+$/;
export const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const poBoxRegex = /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i;

export const validateEditCustomerAccountFields = (
  customerAccountInfo: ResponseCustomerEditAccount
) => {
  let editCustomerAccountErrors = customerEditCustomer;
  let isValidated = true;
  if (customerAccountInfo?.paymentTerms.length < 1) {
    editCustomerAccountErrors.paymentTerms = PAYMENT_TERMS_REQUIRED;
    isValidated = false;
  } else {
    editCustomerAccountErrors.paymentTerms = "";
  }

  if (customerAccountInfo?.affilation.length < 1) {
    editCustomerAccountErrors.affilation = AFFILATION_REQUIRED;
    isValidated = false;
  } else {
    editCustomerAccountErrors.affilation = "";
  }

  if (customerAccountInfo?.authorizedBuyerTitle.length < 1) {
    editCustomerAccountErrors.authorizedBuyerTitle = "Title is Required";
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerTitle =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerTitle
      );
    if (characterCustomerAuthorizedBuyerTitle) {
      editCustomerAccountErrors.authorizedBuyerTitle = "";
    } else {
      editCustomerAccountErrors.authorizedBuyerTitle =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedBuyerFirstName.length < 1) {
    editCustomerAccountErrors.authorizedBuyerFirstName =
      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerFirstName =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerFirstName
      );
    if (characterCustomerAuthorizedBuyerFirstName) {
      editCustomerAccountErrors.authorizedBuyerFirstName = "";
    } else {
      editCustomerAccountErrors.authorizedBuyerFirstName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedBuyerLastName.length < 1) {
    editCustomerAccountErrors.authorizedBuyerLastName =
      AUTHORIZED_BUYER_LASTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerLastName =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerLastName
      );
    if (characterCustomerAuthorizedBuyerLastName) {
      editCustomerAccountErrors.authorizedBuyerLastName = "";
    } else {
      editCustomerAccountErrors.authorizedBuyerLastName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedBuyerPhone.length < 1) {
    editCustomerAccountErrors.authorizedBuyerPhone =
      AUTHORIZED_BUYER_PHONE_REQUIRED;

    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerPhone = phoneNumberRegex.test(
      customerAccountInfo?.authorizedBuyerPhone
    );
    if (characterCustomerAuthorizedBuyerPhone) {
      editCustomerAccountErrors.authorizedBuyerPhone = "";
    } else {
      editCustomerAccountErrors.authorizedBuyerPhone = INVALID_PHONENUMBER;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedEmailId.length < 1) {
    editCustomerAccountErrors.authorizedEmailId =
      AUTHORIZED_BUYER_EMAIL_REQUIRED;

    isValidated = false;
  } else {
    var customerAuthorizedEmailId = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo?.authorizedEmailId
    );
    var characterCustomerAuthorizedEmailId = emailRegex.test(
      customerAccountInfo?.authorizedEmailId
    );
    if (customerAuthorizedEmailId) {
      if (characterCustomerAuthorizedEmailId) {
        editCustomerAccountErrors.authorizedEmailId = "";
      } else {
        editCustomerAccountErrors.authorizedEmailId = EMAIL_VALIDATION;
        isValidated = false;
      }
    } else {
      editCustomerAccountErrors.authorizedEmailId =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }
  return { isValidated, editCustomerAccountErrors };
};

export const validateEditCustomerAddressFields = (
  customerAddresssInfo: ResponseAddress
) => {
  let editCustomerAddressErrors = newAddressCustomerInfoIntialValue;
  let isValidated = true;
  if (
    customerAddresssInfo.name === undefined ||
    customerAddresssInfo?.name.length < 1
  ) {
    editCustomerAddressErrors.name = CUSTOMER_NAME_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerName = allowSpecialCharacterExcludingSome.test(
      customerAddresssInfo?.name
    );
    if (customerAddresssInfo.name?.length > companyNameCharacterLimit) {
      editCustomerAddressErrors.name = COMPANY_NAME_CHARACTER_LIMIT;
      isValidated = false;
    } else if (specialCharacterCustomerName) {
      editCustomerAddressErrors.name = "";
    } else {
      editCustomerAddressErrors.name = SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.street.length < 1) {
    editCustomerAddressErrors.street = STREET_REQUIRED;
    isValidated = false;
  } else {
    var streetLength = customerAddresssInfo?.street?.length;

    var poBoxRegexStreetPattern = poBoxRegex.test(customerAddresssInfo?.street);
    var poBoxRegexSpecialCharacterStreetPattern =
      allowSpecialCharacterExcludingSome.test(customerAddresssInfo?.street);
    if (streetLength <= 60) {
      if (poBoxRegexSpecialCharacterStreetPattern) {
        if (poBoxRegexStreetPattern) {
          editCustomerAddressErrors.street = Street_PO_BOX_VALIDATION;
          isValidated = false;
        } else {
          editCustomerAddressErrors.street = "";
        }
      } else {
        editCustomerAddressErrors.street = SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    } else {
      editCustomerAddressErrors.street =
        "Street Length should not be greater than 60 characters";
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.sapAccountId.length > 0) {
    var characterCustomerSapAccountId = numbersOnly.test(
      customerAddresssInfo?.sapAccountId
    );
    if (characterCustomerSapAccountId) {
      editCustomerAddressErrors.sapAccountId = "";
    } else {
      editCustomerAddressErrors.sapAccountId = NUMBERS_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.city.length < 1) {
    editCustomerAddressErrors.city = CITY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCity = allowSpecialCharacterExcludingSome.test(
      customerAddresssInfo?.city
    );
    if (customerAddresssInfo?.city.length > cityCharacterLimit) {
      editCustomerAddressErrors.city = CITY_CHARACTER_LIMIT;
      isValidated = false;
    } else if (customerAddresssInfo?.city.length > cityCharacterLimit) {
      editCustomerAddressErrors.city = CITY_CHARACTER_LIMIT;
      isValidated = false;
    } else if (characterCustomerCity) {
      editCustomerAddressErrors.city = "";
    } else {
      editCustomerAddressErrors.city =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.postalCode.length < 1) {
    editCustomerAddressErrors.postalCode = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerPostalCode =
      allowSpecialCharacterExcludingSome.test(customerAddresssInfo?.postalCode);
    if (customerAddresssInfo?.postalCode.length > postalCodeCharacterLimit) {
      editCustomerAddressErrors.postalCode = POSTALCODE_CHARACTER_LIMIT;
      isValidated = false;
    } else if (specialCharacterCustomerPostalCode) {
      editCustomerAddressErrors.postalCode = "";
    } else {
      editCustomerAddressErrors.postalCode =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.state.length < 1) {
    editCustomerAddressErrors.state = PROVINCE_REQUIRED;
    isValidated = false;
  } else {
    editCustomerAddressErrors.state = "";
  }

  if (customerAddresssInfo?.contacts?.contactId.length < 1) {
    editCustomerAddressErrors.contacts.contactId = CONTACTS_REQUIRED;
    isValidated = false;
  } else {
    editCustomerAddressErrors.contacts.contactId = "";
  }

  if (customerAddresssInfo.country.length < 1) {
    editCustomerAddressErrors.country = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCountry = letters.test(customerAddresssInfo.country);
    if (characterCustomerCountry) {
      editCustomerAddressErrors.country = "";
    } else {
      editCustomerAddressErrors.country = CHARACTERS_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo.affilation.toLocaleLowerCase() === "billing") {
    if (customerAddresssInfo?.purchasingCompanyTaxId && customerAddresssInfo?.purchasingCompanyTaxId.length > 0) {
      var specialCharacterCustomerPurchasingId =
        allowSpecialCharacterExcludingSome.test(
          customerAddresssInfo?.purchasingCompanyTaxId
        );
      if (
        customerAddresssInfo.purchasingCompanyTaxId.length >
        companyTaxIdCharacterLimit
      ) {
        editCustomerAddressErrors.purchasingCompanyTaxId =
          COMPANY_TAXID_CHARACTER_LIMIT;
        isValidated = false;
      } else if (specialCharacterCustomerPurchasingId) {
        editCustomerAddressErrors.purchasingCompanyTaxId = "";
      } else {
        editCustomerAddressErrors.purchasingCompanyTaxId =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (customerAddresssInfo.affilation.toLocaleLowerCase() === "shipping") {
    if (customerAddresssInfo?.shipmentCompanyTaxId && customerAddresssInfo?.shipmentCompanyTaxId.length > 0) {
      var specialCharacterCustomerShipmentId =
        allowSpecialCharacterExcludingSome.test(
          customerAddresssInfo?.shipmentCompanyTaxId
        );
      if (
        customerAddresssInfo.shipmentCompanyTaxId.length >
        companyTaxIdCharacterLimit
      ) {
        editCustomerAddressErrors.shipmentCompanyTaxId =
          COMPANY_TAXID_CHARACTER_LIMIT;
        isValidated = false;
      } else if (specialCharacterCustomerShipmentId) {
        editCustomerAddressErrors.shipmentCompanyTaxId = "";
      } else {
        editCustomerAddressErrors.shipmentCompanyTaxId =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }

  return { isValidated, editCustomerAddressErrors };
};

export const validateRegisteredAddressFields = (
  customerAddresssInfo: RegisterAddress
) => {
  let editRegisteredAddressErrors = registeredAddressIntialErrorState;
  let isValidated = true;

  if (customerAddresssInfo?.registerStreet.length < 1) {
    editRegisteredAddressErrors.registerStreet = STREET_REQUIRED;
    isValidated = false;
  } else {
    var registeredAddressStreetLength =
      customerAddresssInfo?.registerStreet.length;
    var poBoxRegexStreetPattern = poBoxRegex.test(
      customerAddresssInfo?.registerStreet
    );
    var poBoxRegexSpecialCharacterStreetPattern =
      allowSpecialCharacterExcludingSome.test(
        customerAddresssInfo?.registerStreet
      );

    if (registeredAddressStreetLength <= 60) {
      if (poBoxRegexSpecialCharacterStreetPattern) {
        if (poBoxRegexStreetPattern) {
          editRegisteredAddressErrors.registerStreet = Street_PO_BOX_VALIDATION;
          isValidated = false;
        } else {
          editRegisteredAddressErrors.registerStreet = "";
        }
      } else {
        editRegisteredAddressErrors.registerStreet =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    } else {
      editRegisteredAddressErrors.registerStreet =
        "Street Length should not be greater than 60 characters";
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.registerCity.length < 1) {
    editRegisteredAddressErrors.registerCity = CITY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCity = allowSpecialCharacterExcludingSome.test(
      customerAddresssInfo?.registerCity
    );
    if (characterCustomerCity) {
      editRegisteredAddressErrors.registerCity = "";
    } else {
      editRegisteredAddressErrors.registerCity =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAddresssInfo?.registerTaxId && customerAddresssInfo?.registerTaxId.length > 0) {
    var characterCustomerTaxId = allowSpecialCharacterExcludingSome.test(
      customerAddresssInfo?.registerTaxId
    );
    if (characterCustomerTaxId) {
      editRegisteredAddressErrors.registerTaxId = "";
    } else {
      editRegisteredAddressErrors.registerTaxId =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  } else {
    editRegisteredAddressErrors.registerTaxId = "";
  }

  if (customerAddresssInfo?.registerPostal.length < 1) {
    editRegisteredAddressErrors.registerPostal = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerPostalCode =
      allowSpecialCharacterExcludingSome.test(
        customerAddresssInfo?.registerPostal
      );
    if (specialCharacterCustomerPostalCode) {
      editRegisteredAddressErrors.registerPostal = "";
    } else {
      editRegisteredAddressErrors.registerPostal =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }
  if (customerAddresssInfo?.registerState.length < 1) {
    editRegisteredAddressErrors.registerState = PROVINCE_REQUIRED;
    isValidated = false;
  } else {
    editRegisteredAddressErrors.registerState = "";
  }

  if (customerAddresssInfo.registerCountry.length < 1) {
    editRegisteredAddressErrors.registerCountry = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCountry = letters.test(
      customerAddresssInfo.registerCountry
    );
    if (characterCustomerCountry) {
      editRegisteredAddressErrors.registerCountry = "";
    } else {
      editRegisteredAddressErrors.registerCountry = CHARACTERS_ALLOWED;
      isValidated = false;
    }
  }
  if (customerAddresssInfo?.registerSapAccountId.length > 0) {
    var specialCharacterCustomerSapAccountId = numbersOnly.test(
      customerAddresssInfo?.registerSapAccountId
    );
    if (specialCharacterCustomerSapAccountId) {
      editRegisteredAddressErrors.registerSapAccountId = "";
    } else {
      editRegisteredAddressErrors.registerSapAccountId = NUMBERS_ALLOWED;
      isValidated = false;
    }
  }

  if (
    customerAddresssInfo?.registerCustomerCertifiedEmail === undefined ||
    customerAddresssInfo?.registerCustomerCertifiedEmail.length > 1
  ) {
    var emailCustomerAuthorizedEmailId =
      allowSpecialCharacterExcludingSome.test(
        customerAddresssInfo?.registerCustomerCertifiedEmail
      );
    var characterCustomerAuthorizedEmailId = emailRegex.test(
      customerAddresssInfo?.registerCustomerCertifiedEmail
    );

    if (
      customerAddresssInfo?.registerCustomerCertifiedEmail?.length >
      emailCharacterLimit
    ) {
      editRegisteredAddressErrors.registerCustomerCertifiedEmail =
        EMAIL_CHARACTER_LIMIT;
      isValidated = false;
    } else if (emailCustomerAuthorizedEmailId) {
      if (characterCustomerAuthorizedEmailId) {
        editRegisteredAddressErrors.registerCustomerCertifiedEmail = "";
      } else {
        editRegisteredAddressErrors.registerCustomerCertifiedEmail =
          EMAIL_VALIDATION;
        isValidated = false;
      }
    } else {
      editRegisteredAddressErrors.registerCustomerCertifiedEmail =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  // Check if Customer Certified Email is mandatory for Italy
  if (customerAddresssInfo?.registerCountry?.toLowerCase() === "italy") {
    if (!customerAddresssInfo?.registerCustomerCertifiedEmail || 
        customerAddresssInfo?.registerCustomerCertifiedEmail?.trim() === "") {
      editRegisteredAddressErrors.registerCustomerCertifiedEmail = CUSTOMER_CERTIFIED_EMAIL_REQUIRED;
      isValidated = false;
    }
  } else {
    // Clear the error if country is not Italy
    editRegisteredAddressErrors.registerCustomerCertifiedEmail = "";
  }

  // Check if Customer Consignee Code is mandatory for Italy
  if (customerAddresssInfo?.registerCountry?.toLowerCase() === "italy") {
    if (!customerAddresssInfo?.registerCustomerConsigneeCode || 
        customerAddresssInfo?.registerCustomerConsigneeCode?.trim() === "") {
      editRegisteredAddressErrors.registerCustomerConsigneeCode = CUSTOMER_CONSIGNEE_CODE_REQUIRED;
      isValidated = false;
    }
  } else {
    // Clear the error if country is not Italy
    editRegisteredAddressErrors.registerCustomerConsigneeCode = "";
  }

  if (customerAddresssInfo?.registerCustomerConsigneeCode.length > 1) {
    var specialCharacterCustomerConsigneeCode =
      allowSpecialCharacterExcludingSome.test(
        customerAddresssInfo?.registerCustomerConsigneeCode
      );
    if (specialCharacterCustomerConsigneeCode) {
      editRegisteredAddressErrors.registerCustomerConsigneeCode = "";
    } else {
      editRegisteredAddressErrors.registerCustomerConsigneeCode =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  return { isValidated, editRegisteredAddressErrors };
};

export const validateEditCustomerContactFields = (
  customerContactInfo: CustomerContact
) => {
  let editRegisteredContactErrors = registeredContactIntialErrorState;
  let isValidated = true;
  if (
    customerContactInfo?.contactFirstName === undefined ||
    customerContactInfo.contactFirstName.length < 1
  ) {
    editRegisteredContactErrors.contactFirstName =
      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerContactFirstName =
      allowSpecialCharacterExcludingSome.test(
        customerContactInfo?.contactFirstName
      );
    if (
      customerContactInfo?.contactFirstName?.length > contactNameCharacterLimit
    ) {
      editRegisteredContactErrors.contactFirstName =
        CONTACT_FIRSTNAME_CHARACTER_LIMIT;
      isValidated = false;
    } else if (characterCustomerContactFirstName) {
      editRegisteredContactErrors.contactFirstName = "";
    } else {
      editRegisteredContactErrors.contactFirstName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (
    customerContactInfo?.contactLastName === undefined ||
    customerContactInfo?.contactLastName.length < 1
  ) {
    editRegisteredContactErrors.contactLastName =
      AUTHORIZED_BUYER_LASTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerContactLastName =
      allowSpecialCharacterExcludingSome.test(
        customerContactInfo.contactLastName
      );
    if (
      customerContactInfo?.contactLastName?.length > contactNameCharacterLimit
    ) {
      editRegisteredContactErrors.contactLastName =
        CONTACT_LASTNAME_CHARACTER_LIMIT;
      isValidated = false;
    } else if (characterCustomerContactLastName) {
      editRegisteredContactErrors.contactLastName = "";
    } else {
      editRegisteredContactErrors.contactLastName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (
    customerContactInfo?.contactPhone === undefined ||
    customerContactInfo?.contactPhone.length < 1
  ) {
    editRegisteredContactErrors.contactPhone = AUTHORIZED_BUYER_PHONE_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerContactPhone = phoneNumberRegex.test(
      customerContactInfo?.contactPhone
    );
    if (characterCustomerContactPhone) {
      editRegisteredContactErrors.contactPhone = "";
    } else {
      editRegisteredContactErrors.contactPhone = INVALID_PHONENUMBER;
      isValidated = false;
    }
  }

  if (
    customerContactInfo?.contactEmail === undefined ||
    customerContactInfo?.contactEmail.length < 1
  ) {
    editRegisteredContactErrors.contactEmail = AUTHORIZED_BUYER_EMAIL_REQUIRED;
    isValidated = false;
  } else {
    var emailCustomerAuthorizedEmailId =
      allowSpecialCharacterExcludingSome.test(
        customerContactInfo?.contactEmail
      );
    var characterCustomerAuthorizedEmailId = emailRegex.test(
      customerContactInfo?.contactEmail
    );

    if (customerContactInfo?.contactEmail?.length > emailCharacterLimit) {
      editRegisteredContactErrors.contactEmail = EMAIL_CHARACTER_LIMIT;
      isValidated = false;
    } else if (emailCustomerAuthorizedEmailId) {
      if (characterCustomerAuthorizedEmailId) {
        editRegisteredContactErrors.contactEmail = "";
      } else {
        editRegisteredContactErrors.contactEmail = EMAIL_VALIDATION;
        isValidated = false;
      }
    } else {
      editRegisteredContactErrors.contactEmail =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (
    customerContactInfo?.contactEmail === undefined ||
    customerContactInfo?.contactEmail.length < 1
  ) {
    editRegisteredContactErrors.contactEmail = AUTHORIZED_BUYER_EMAIL_REQUIRED;
    isValidated = false;
  } else {
    var emailCustomerAuthorizedEmailId =
      allowSpecialCharacterExcludingSome.test(
        customerContactInfo?.contactEmail
      );
    var characterCustomerAuthorizedEmailId = emailRegex.test(
      customerContactInfo?.contactEmail
    );

    if (customerContactInfo?.contactEmail?.length > emailCharacterLimit) {
      editRegisteredContactErrors.contactEmail = EMAIL_CHARACTER_LIMIT;
      isValidated = false;
    } else if (emailCustomerAuthorizedEmailId) {
      if (characterCustomerAuthorizedEmailId) {
        editRegisteredContactErrors.contactEmail = "";
      } else {
        editRegisteredContactErrors.contactEmail = EMAIL_VALIDATION;
        isValidated = false;
      }
    } else {
      editRegisteredContactErrors.contactEmail =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }
  return { isValidated, editRegisteredContactErrors };
};